import { Drawer } from "@mui/material";
import { styled } from "@mui/material/styles";

const DRAWER_WIDTH = 240;
const DRAWER_COLLAPSED_WIDTH = 56;

export const StyledDrawer = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== "customOpen",
})<{ customOpen?: boolean }>(({ theme, customOpen }) => ({
  width: customOpen ? DRAWER_WIDTH : DRAWER_COLLAPSED_WIDTH,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.standard,
  }),

  "& .MuiDrawer-paper": {
    width: customOpen ? DRAWER_WIDTH : DRAWER_COLLAPSED_WIDTH,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.standard,
    }),
    overflowX: "hidden",
    position: "fixed",
    height: "100vh",
  },

  [theme.breakpoints.up("sm")]: {
    position: "relative",
    height: "auto",
    zIndex: theme.zIndex.drawer,

    "& .MuiDrawer-paper": {
      width: customOpen ? 240 : theme.spacing(7),
      overflowX: "hidden",
      position: "fixed",
      height: "100vh",
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),      
    },
  },

  [theme.breakpoints.down("sm")]: {
    position: "fixed",
    zIndex: theme.zIndex.modal + 1,

    "& .MuiDrawer-paper": {
      width: 240,
      position: "fixed",
      height: "100vh",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
  },
}));

export const ToolbarSpacer = styled("div")(({ theme }) => ({
  ...theme.mixins.toolbar,
}));
